import { render, staticRenderFns } from "./Tip.vue?vue&type=template&id=42a8a82f&scoped=true"
import script from "./Tip.vue?vue&type=script&lang=js"
export * from "./Tip.vue?vue&type=script&lang=js"
import style0 from "./Tip.vue?vue&type=style&index=0&id=42a8a82f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a8a82f",
  null
  
)

export default component.exports